import { render, staticRenderFns } from "./DesignModal.vue?vue&type=template&id=4dd12d99"
import script from "./DesignModal.vue?vue&type=script&lang=ts"
export * from "./DesignModal.vue?vue&type=script&lang=ts"
import style0 from "./DesignModal.vue?vue&type=style&index=0&id=4dd12d99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports